import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { AdminLayout } from './components/layouts/AdminLayout';
import { MemberLayout } from './components/layouts/MemberLayout';
import RegisterPage from './pages/RegisterPage';

// Admin Pages
import { AdminDashboardPage } from './pages/admin/DashboardPage';
import { MembersPage } from './pages/admin/MembersPage';
import { ServiceRequestsPage } from './pages/admin/ServiceRequestsPage';
import { PartnersPage } from './pages/admin/PartnersPage';
import { BenefitsPage as AdminBenefitsPage } from './pages/admin/BenefitsPage';
import { PaymentsPage as AdminPaymentsPage } from './pages/admin/PaymentsPage';
import { AnalyticsPage } from './pages/admin/AnalyticsPage';
import { NotificationsPage as AdminNotificationsPage } from './pages/admin/NotificationsPage';
import { AuditLogsPage } from './pages/admin/AuditLogsPage';

// Member Pages
import { MemberDashboardPage } from './pages/member/DashboardPage';
import { CreateRequestPage } from './pages/member/CreateRequestPage';
import { ProfilePage } from './pages/member/ProfilePage';
import { RequestsPage } from './pages/member/RequestsPage';
import { AppointmentsPage } from './pages/member/AppointmentsPage';
import { BenefitsPage as MemberBenefitsPage } from './pages/member/BenefitsPage';
import { PaymentsPage as MemberPaymentsPage } from './pages/member/PaymentsPage';
import { NotificationsPage as MemberNotificationsPage } from './pages/member/NotificationsPage';
import { SupportPage } from './pages/member/SupportPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage type="MEMBER" />} />
          <Route path="/admin/login" element={<LoginPage type="ADMIN" />} />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="ADMIN">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboardPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="requests" element={<ServiceRequestsPage />} />
            <Route path="partners" element={<PartnersPage />} />
            <Route path="benefits" element={<AdminBenefitsPage />} />
            <Route path="payments" element={<AdminPaymentsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="notifications" element={<AdminNotificationsPage />} />
            <Route path="audit-logs" element={<AuditLogsPage />} />
          </Route>

          {/* Member Routes */}
          <Route
            path="/member"
            element={
              <ProtectedRoute requiredRole="MEMBER">
                <MemberLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<MemberDashboardPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="requests" element={<RequestsPage />} />
            <Route path="requests/new" element={<CreateRequestPage />} />
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="benefits" element={<MemberBenefitsPage />} />
            <Route path="payments" element={<MemberPaymentsPage />} />
            <Route path="notifications" element={<MemberNotificationsPage />} />
            <Route path="support" element={<SupportPage />} />
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </AuthProvider>
  );
}

export default App;
